import React, { FC, ReactElement, useEffect } from 'react';
import styled from 'styled-components';
import Set from '../../set/Set';
import './Simple.scss';

type simpleProps = {
    index:number|null,
    path: {
        slideIndex:number,
        comboIndex:number,
        setIndex: number|null,
        groupIndex: number|null,
        elementIndex: number|null,
    }|null,
    activePath:{
        slideIndex:number,
        comboIndex:number|null,
        setIndex: number|null,
        groupIndex: number|null,
        elementIndex: number|null,
    } | null,
    name:string,
    editorPlugins: any|null,
    settings: {
        horizontalAlignment: string,
        verticalAlignment: string
        maxWidth: string,
    },
    setsWidth: string,
    sets: any,
}

type simpleComboProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
    maxWidth: string,
    setsWidth: string
}

const SimpleCombo = styled.div<simpleComboProps>`
    .set {
        flex: 0 0 ${props => props.setsWidth + '%'};
        width: ${props => props.setsWidth + '%'};
    }
`;


const Simple:FC<simpleProps> = ({...props}) : ReactElement => {

    const set = props.sets[0];

    function setInstance(index: number, setData:any) {
        return <Set key={index} {...setData} editorPlugins={props.editorPlugins} index={index} path={getPath(index)}/>
    }

    function getPath(index:number) {
        if(!props.path) return null;
        let path = {...props.path};
        path.setIndex = index;
        return path;
    }

    return (
        <SimpleCombo className={"combo simpleCombo"} verticalAlignment={props.settings.verticalAlignment} horizontalAlignment={props.settings.horizontalAlignment} maxWidth={props.settings.maxWidth} setsWidth={props.setsWidth}>
            <Set {...set} editorPlugins={props.editorPlugins} index={0} path={getPath(0)}/>
        </SimpleCombo>
    )

};
export default Simple;
